import { createActionGroup, props } from '@ngrx/store';
import { EPdfContentType } from '../../components/transcriptions/components/pdf-content-selection-dialog/pdf-content-selection-dialog.component';

export const PDF_EXPORT_ACTIONS = createActionGroup({
  source: 'PDS Export',
  events: {
    export: props<{ selectedContent: EPdfContentType[] }>(),
  },
});
